export default "__VITE_ASSET__CQPI2rJk__"